import { compose, withProps } from 'recompose';

import Date from './date';
import config from '../../config';
import withDateFormat from '../auth/utils/withDateFormat';


export default compose(
  withDateFormat(),
  withProps(props => ({
    format: `${props.dateFormat} ${config.timeFormat}`,
  })),
)(Date);
